<div
  id="dashboard-modal"
  class="fade-scale in"
  style="background-color: rgba(0, 0, 0, 0.1); display: block"
>
  <div
    class="modal-dialog"
    style="margin-top: 5%; display: table; width: auto; margin: 0 !important"
  >
    <div
      class="modal-content"
      style="
        border: solid 1px #aaaaaa;
        padding: 10px;
        height: auto;
        width: 650px;
      "
    >
      <div class="modal-body" [innerHtml]="html | sanitizeHtml"></div>

      <div class="div">
        <div class="checkbox_temp" >
          <span [innerHtml]="htmlCheckbox | sanitizeHtml"></span>
          <input
          *ngIf="!showCheckobox"
          type="checkbox"
          [(ngModel)]="expiryValue"
          (change)="term($event)"
          id="dont-show"
        />
        </div>
        
        <button
          id="dont-show-btn"
          type="button"
          class="btn gernal-btn"
          data-dismiss="modal"
          [disabled]="isReadOnly"
          (click)="close()"

        >
          Go to map!
        </button>
      </div>
    </div>
  </div>
</div>
